// extracted by mini-css-extract-plugin
export default {"headerBar":"EditHospital_headerBar__rPplf"};